import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Giving up ownership is owner-only and maps to the backend's `can_share` gate
// (conferred only by `is_manager`). Unlike the other `useCan*Agent` hooks this
// deliberately omits the `admin:agents` bypass: an admin who isn't a real owner
// holds no direct tuple to remove and would be rejected. SYSTEM agents are owned
// by the seed YAML, so leaving is unavailable there. Editors have no other
// sharing privileges, so editor-leave is intentionally not built yet.
export const useCanLeaveAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.scope === AgentScope.CUSTOMER && agent.access_level === AgentAccessLevel.OWNER;
